import React, { useState } from 'react';
import './plaza.scss';
import PartySelector from './partySelector';
import PlazaRange from './plazaRange';
import PlazaCloud from './plazaCloud';
import { parties } from '../../constants/parties.js';
import { SentisisLogo } from '../../constants/logos.js';
import * as Axios from 'axios';
import { twitter } from '../../constants/api';
import { topicChartColors } from '../../constants/colors';
import { PATH } from '../../envs/core';
import { ChartTitle } from './chartTitle';
import { Fragment } from 'react';
import { PlazaChart } from './plazaChart';
import { PlazaList } from './plazaList';

const dateToString = (date = new Date()) => {
  const day =
    date.getDate().toString().length === 1
      ? `0${date.getDate()}`
      : date.getDate();
  const month =
    (date.getMonth() + 1).toString().length === 1
      ? `0${date.getMonth() + 1}`
      : date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}${month}${day}`;
};

const getRangeDate = (date = new Date(), date2 = new Date()) =>
  `${dateToString(date)}-${dateToString(date2)}`;

let dayMarks = [];

let partyDataSnapshot;
const Plaza = () => {
  // hasta que este los datos correctos usamos el pp como partido incial
  const [selected, setSelected] = useState(false);
  const [wordsApi, setWordsApi] = useState([]);
  const [topicList, setTopicList] = useState([]);

  const partyChange = i => {
    if (selected === i) {
      // hasta que este los datos correctos usamos el pp como partido incial
      setSelected(false);
      setSelectedData(false);
    } else {
      setSelected(i);
      setSelectedData(i);
    }
  };

  const setSelectedData = selectedParty => {
    let sel = selectedParty !== false ? parties[selectedParty].key : 'all';
    const partySelData = partyDataSnapshot.groups.find(
      partyD => partyD.name === sel
    ) || { tags: [], topics: [] };
    const wordsFilter = partySelData.tags.map(word => ({
      text: word.name,
      value: word.total
    }));
    const total = partySelData.topics.reduce(
      (sum, { total }) => sum + total,
      0
    );
    const topicsFilter = partySelData.topics
      .map((topic, index) => ({
        name: topic.name,
        color: topicChartColors[index],
        total: topic.total,
        favs: topic.favs,
        rts: topic.rts,
        share: topic.share,
        percent: topic.total / total
      }))
      .sort((a, b) => {
        if (a.total > b.total) {
          return -1;
        }
        if (a.total < b.total) {
          return 1;
        }
        return 0;
      });

    setTopicList(topicsFilter);
    setWordsApi(wordsFilter);
  };

  const getData = param => {
    console.log('getData:', param);
    Axios.get(`${PATH}${twitter}/${param}`).then(({ data }) => {
      partyDataSnapshot = data.data;
      console.log(data, 'data');
      setSelectedData(selected);
    });
  };

  const rangeChange = range => {
    getData(getRangeDate(range[0], range[1]));
  };
  return (
    <div className="pagePlaza">
      <div className="header">
        <div className="container">
          <h1 className="title">
            ASÍ INTENTAN DIRIGIR LA CONVERSACIÓN LOS POLÍTICOS
          </h1>
          <h2 className="subtitle font-gotham-book">
            Pincha sobre cada uno de los candidatos y partidos para conocer las
            principales tendencias de su conversación en Twitter durante la
            campaña previa a las elecciones generales del 10 de noviembre de
            2019.
          </h2>
        </div>
      </div>
      <PartySelector
        parties={parties}
        current={selected}
        onChange={partyChange}
      />
      <div className="partyContent">
        <div className="container">
          <ChartTitle
            party={parties[selected]}
            onReset={() => partyChange(false)}
          />
          <div className="dataContainer">
            {topicList.length > 0 && (
              <Fragment>
                <div className="dataSection graphWrapper">
                  <div className="graphContainer">
                    <div
                      className={
                        parties[selected]
                          ? 'personContainer'
                          : 'personContainer empty'
                      }
                    >
                      {parties[selected] && (
                        <Fragment>
                          <img
                            src={parties[selected].person.photo}
                            alt={parties[selected].name}
                            style={{ backgroundColor: parties[selected].color }}
                          />
                          <div
                            className="txt"
                            style={{ backgroundColor: parties[selected].color }}
                          >
                            {parties[selected].shortname}
                          </div>
                        </Fragment>
                      )}
                      {!parties[selected] && (
                        <div className="txt">Todos los partidos</div>
                      )}
                    </div>
                    <PlazaChart party={parties[selected]} topics={topicList} />
                  </div>
                </div>
                <div className="listContainer dataSection">
                  {topicList && <PlazaList topics={topicList} />}
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
      <div className="sliderContainer container">
        <PlazaRange onChange={rangeChange} dayMarks={dayMarks} />
      </div>
      <div className="cloudContainer">
        <PlazaCloud data={wordsApi} />
      </div>
      <div className="footer_plaza">
        <div className="container">
          <a
            href="https://sentisis.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={SentisisLogo} alt="Ir a la web de Sentisis" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Plaza;
